import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PatientHistory, PatientHistoryAction } from '../types';
import * as legacyRecords from 'state/records/types';

const name = 'medicalRecords/currentRecord';

export const initialState: PatientHistory = {};

const patientHistorySlice = createSlice({
  name,
  initialState,
  reducers: {
    setHistoryQuestion: (
      state,
      action: PayloadAction<PatientHistoryAction>,
    ) => {
      const { question, response, observation } = action.payload;

      return {
        ...state,
        [question]: {
          response,
          observation: response && observation ? observation : undefined,
        },
      };
    },
  },
  extraReducers: {
    [legacyRecords.INITIALIZED]: () => initialState,
  },
});

export const { setHistoryQuestion } = patientHistorySlice.actions;

export default patientHistorySlice.reducer;
